import { RightOutlined } from '@ant-design/icons';
import { List, type MenuProps } from 'antd';
import { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import { useSingleDealerId } from '../../../components/contexts/DealerContextManager';
import Dropdown from '../../../components/Dropdown';
import useTranslatedString from '../../../utilities/useTranslatedString';

const ListItem = styled(List.Item)`
    cursor: pointer;

    .ant-list-item-meta-title {
        margin-bottom: 0px;
    }
    .ant-list-item-meta-description {
        color: rgba(0, 0, 0, 0.75);
    }
`;

const DealerSelector = () => {
    const company = useCompany();
    const { dealerId, dealerOptions, toggle } = useSingleDealerId();
    const translate = useTranslatedString();

    const dealer = useMemo(() => dealerOptions.find(item => item.value === dealerId), [dealerOptions, dealerId]);

    const items = useMemo<MenuProps['items']>(
        () =>
            dealerOptions.map(item => ({
                ...item,
                key: item.value,
            })),
        [dealerOptions]
    );

    const handleClickMenu = useCallback<MenuProps['onClick']>(
        ev => {
            if (dealerId && ev.key !== dealerId) {
                toggle(ev.key);
            }
        },
        [toggle, dealerId]
    );

    return (
        <Dropdown
            menu={{
                items,
                selectedKeys: dealerId ? [dealerId] : [],
                selectable: true,
                onClick: handleClickMenu,
            }}
        >
            <ListItem key="dealerInfo">
                <List.Item.Meta description={dealer?.label} title={translate(company.legalName)} />
                <RightOutlined />
            </ListItem>
        </Dropdown>
    );
};

export default DealerSelector;
